
import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import BoxWithIcon from "../atoms/ComponentBox/BoxWithIcon";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { selectPermissions } from '../redux/permissionsSlice';
import fetchStatusCounts from "../GlobalFunction/Counts";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const Property = () => {
  const names = [
    "Wing",
    "Floor",
    "Room Type",
    "Room View",
    "Room Bed",
    "Room Master",
    "Room Bed Number",
    "Facilities Master",
    "Room Type Facilities Link",
    "Room Facility Link",
  ];
  const location = useLocation();
  const navigate = useNavigate();

  const permissions = useSelector(selectPermissions);
  const [counts, setCounts] = useState([]);

  const hasModulePermission = (moduleName) => {
    const modulePermission = permissions.find(
      permission => permission.ModuleName === moduleName
    );

    if (!modulePermission) return false;

    return (
      modulePermission.AddRec === "1" ||
      modulePermission.EditRec === "1" ||
      modulePermission.DeleteRec === "1" ||
      modulePermission.ViewRec === "1"
    );
  };

  // Parent id for status count
  const parentId = 11;

  // count api call
  useEffect(() => {
    const getCounts = async () => {
      const data = await fetchStatusCounts(parentId);
      setCounts(data);
    };
    getCounts();
  }, [parentId])

  // Function to find module name
  const matchedItem = (moduleName) => {
    return counts.find(item => item.ModuleName === moduleName);
  };

  // Store match count data for each module
  const matchProperty = matchedItem('Property Master');
  const matchPropTypeMst = matchedItem('Prop Type Master')
  const matchRoom = matchedItem('Room Master');
  const matchBed = matchedItem('Bed Master');
  const matchWing = matchedItem('Wing Master');
  const matchFloor = matchedItem('Floor Master');
  const matchRoomType = matchedItem('Room Type Master');
  const matchBedType = matchedItem('BedType Master');
  const matchRoomView = matchedItem('Room View');
  const matchFacilities = matchedItem('Facilities Master');
  const matchAmenities = matchedItem('Amenities Master');
  const matchCommonArea = matchedItem('Common Area Master');
  const matchGenerate = matchedItem('Generate Calender');

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        sx={{
          width: "100%",
          maxWidth: "100%"
        }}
      >
        <Grid item xs={12}>
          <Grid container spacing={1}>
            {hasModulePermission("Property Master") && matchProperty && (
              <BoxWithIcon
                totalCount={matchProperty.TotalCount}
                activeCount={matchProperty.ActiveCount}
                inactiveCount={matchProperty.InactiveCount}
                title="Property Master"
                link={{ pathname: "/propertytable" }}
                permissions={permissions}
              />
            )}

            {hasModulePermission("Room Master") && matchRoom && (
              <BoxWithIcon
                totalCount={matchRoom.TotalCount}
                activeCount={matchRoom.ActiveCount}
                inactiveCount={matchRoom.InactiveCount}
                link={{ pathname: "/room-master-table" }}
                title="Room Master"
                permissions={permissions}
              />
            )}

            {hasModulePermission("Bed Master") && matchBed && (
              <BoxWithIcon
                totalCount={matchBed.TotalCount}
                activeCount={matchBed.ActiveCount}
                inactiveCount={matchBed.InactiveCount}
                link={{ pathname: "/roomBednumbertable" }}
                permissions={permissions}
                title="Bed Master"
              />
            )}

            {hasModulePermission("Wing Master") && matchWing && (
              <BoxWithIcon
                totalCount={matchWing.TotalCount}
                activeCount={matchWing.ActiveCount}
                inactiveCount={matchWing.InactiveCount}
                link={{ pathname: "/wingtable" }}
                permissions={permissions}
                title="Wing Master"
              />
            )}
            {hasModulePermission("Floor Master") && matchFloor && (
              <BoxWithIcon
                totalCount={matchFloor.TotalCount}
                activeCount={matchFloor.ActiveCount}
                inactiveCount={matchFloor.InactiveCount}
                link={{ pathname: "/floortable" }}
                permissions={permissions}
                title="Floor Master"
              />
            )}
            {hasModulePermission("Prop Type Master") && matchPropTypeMst && (
              <BoxWithIcon
                totalCount={matchPropTypeMst.TotalCount}
                activeCount={matchPropTypeMst.ActiveCount}
                inactiveCount={matchPropTypeMst.InactiveCount}
                link={{ pathname: "/propertyTypetable" }}
                permissions={permissions}
                title="PropertyType Master"
              />
            )}


            {hasModulePermission("Room Type Master") && matchRoomType && (
              <BoxWithIcon
                totalCount={matchRoomType.TotalCount}
                activeCount={matchRoomType.ActiveCount}
                inactiveCount={matchRoomType.InactiveCount}

                link={{ pathname: "/roomTypetable" }}
                permissions={permissions}
                title="Room Type Master"
              />
            )}

            {hasModulePermission("BedType Master") && matchBedType && (
              <BoxWithIcon
                totalCount={matchBedType.TotalCount}
                activeCount={matchBedType.ActiveCount}
                inactiveCount={matchBedType.InactiveCount}
                link={{ pathname: "/roomBedTypetable" }}
                permissions={permissions}
                title="BedType Master"
              />
            )}
            {hasModulePermission("Room View") && matchRoomView && (
              <BoxWithIcon
                totalCount={matchRoomView.TotalCount}
                activeCount={matchRoomView.ActiveCount}
                inactiveCount={matchRoomView.InactiveCount}
                link={{ pathname: "/roomViewtable" }}
                permissions={permissions}
                title="Room View"
              />
            )}

            {hasModulePermission("Facilities Master") && matchFacilities && (
              <BoxWithIcon
                totalCount={matchFacilities.TotalCount}
                activeCount={matchFacilities.ActiveCount}
                inactiveCount={matchFacilities.InactiveCount}
                link={{ pathname: "/facilitiesmastertable" }}
                permissions={permissions}
                title="Facilities Master"
              />
            )}
            {hasModulePermission("Amenities Master") && matchAmenities && (
              <BoxWithIcon
                totalCount={matchAmenities.TotalCount}
                activeCount={matchAmenities.ActiveCount}
                inactiveCount={matchAmenities.InactiveCount}
                link={{ pathname: "/amenitytable" }}
                permissions={permissions}
                title="Amenities Master"
              />
            )}

            {hasModulePermission("Common Area Master") && matchCommonArea && (
              <BoxWithIcon
                totalCount={matchCommonArea.TotalCount}
                activeCount={matchCommonArea.ActiveCount}
                inactiveCount={matchCommonArea.InactiveCount}
                link={{ pathname: "/commonareatable" }}
                permissions={permissions}
                title="Common Area Master"
              />
            )}
            {hasModulePermission("New Calender") && matchGenerate && (
              <BoxWithIcon
                totalCount={matchGenerate.TotalCount}
                activeCount={matchGenerate.ActiveCount}
                inactiveCount={matchGenerate.InactiveCount}
                link={{ pathname: "/newcalender" }}
                permissions={permissions}
                title="New Calendar"
              />
            )}

            {hasModulePermission("Generate Calender") && matchGenerate && (
              <BoxWithIcon
                totalCount={matchGenerate.TotalCount}
                activeCount={matchGenerate.ActiveCount}
                inactiveCount={matchGenerate.InactiveCount}
                link={{ pathname: "/generatecalender" }}
                permissions={permissions}
                title="Show Calendar"
              />
            )}

            {hasModulePermission("Bed Category") && (
              <BoxWithIcon
                totalCount={10}
                activeCount={10}
                inactiveCount={0}
                link={{ pathname: '/bedcategory' }}
                permissions={permissions}
                title="Bed Category"
              />
            )}

            {hasModulePermission("Record Calender") && matchGenerate && (
              <BoxWithIcon
                totalCount={matchGenerate.TotalCount}
                activeCount={matchGenerate.ActiveCount}
                inactiveCount={matchGenerate.InactiveCount}
                link={{ pathname: "/recordecalender" }}
                permissions={permissions}
                title="Record Calendar"
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
export default Property;
